/* eslint-disable jira/filename-case */
export const JIRASERVICEMANAGEMENT = 'jiraServiceManagement' as const;

export type Solutions = 'jiraServiceManagement';
